import { createContext } from "react";

import { AccessResult } from "utils/access";

import { ScanSettingsItem } from "./gql";

type ScanSettingsContextDataProps = {
  scanSettings: ScanSettingsItem;
  canUpdateScan: AccessResult;
};

export const ScanSettingsContextData = createContext<ScanSettingsContextDataProps | undefined>(
  undefined
);
